import SetUserEmail from '../Widgets/Email';
import SetPassword from '../Widgets/SetPassword';
import SetPasswordAndConfirm from '../Widgets/SetPasswordAndConfirm';
import SetParentalUnitName from '../Widgets/ParentName';
import SetParentDob from '../Widgets/DateOfBirth';
import AddChildInfo from '../Widgets/AddChild';
import SetFirstName from '../Widgets/FirstName';
import SetLastName from '../Widgets/LastName';
import SetUserGender from '../Widgets/Gender';
import ParentPhoneNumber from '../Widgets/ParentPhoneNumber';
import SetLegalAddress from '../Widgets/Address';
import SetUserSsn from '../Widgets/SSN';
import AcceptTerms from '../Widgets/AcceptTerms';
import SetInitialFundingAmount from '../Widgets/FundWallet';
import SetFundingAccount from '../Widgets/FundingAccount/index.tsx';
import SetPlan from '../Widgets/SetPlan/index.tsx';
import ProvePrefillContainer from '../Widgets/ProvePrefill/container';
import ProveReview from '../Widgets/ProveReview';
import SetAutofundingPreference from '../Widgets/AutofundingToggle';
import ReferralCode from '../Widgets/ReferralCode';
import Complete from '../Widgets/Complete';
import MockWidget from '../../test-utils/MockWidget';
import CreditApplication from '../Widgets/CreditApplication/index.tsx';

const Components = {};
Components.SetUserEmail = SetUserEmail;
Components.SetUserPassword = SetPassword;
Components.SetUserPasswordAndConfirm = SetPasswordAndConfirm;
Components.SetParentalUnitName = SetParentalUnitName;
Components.SetUserDateOfBirth = SetParentDob;
Components.AddChildInfo = AddChildInfo;
Components.SetLegalFirstName = SetFirstName;
Components.SetLegalLastName = SetLastName;
Components.SetUserFirstName = SetFirstName;
Components.SetUserLastName = SetLastName;
Components.SetUserGender = SetUserGender;
Components.SetParentPhoneNumber = ParentPhoneNumber;
Components.SetLegalAddress = SetLegalAddress;
Components.SetUserSsnLast4 = SetUserSsn;
Components.SetUserSsn = SetUserSsn;
Components.AcceptTerms = AcceptTerms;
Components.SetInitialFundingAmount = SetInitialFundingAmount;
Components.SetFundingAccount = SetFundingAccount;
Components.SetPlan = SetPlan;
Components.ProvePrefill = ProvePrefillContainer;
Components.ProveReview = ProveReview;
Components.SetAutofundingPreference = SetAutofundingPreference;
Components.SetReferralCode = ReferralCode;
Components.Complete = Complete;
Components.CreditApplication = CreditApplication;

Components.MockWidget = MockWidget;
Components.MockWidget2 = MockWidget;

export default Components;
